import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

const SITE_NAME = "D Soto Cleaning";
const SITE_URL = "https://dsotocleaning.com";
const DEFAULT_OG_IMAGE = "https://customer-assets.emergentagent.com/job_dsoto-corporate/artifacts/tp4zyo79_D%20Soto%20Cleaning%20Logo%20Color%202.png";

const SEO = ({ 
  title, 
  description, 
  keywords,
  canonical,
  ogImage,
  ogType = "website",
  noIndex = false
}) => {
  const { i18n } = useTranslation();
  const lang = i18n.language || 'en';
  const altLang = lang === 'en' ? 'es' : 'en';

  const fullTitle = title ? `${title} | ${SITE_NAME}` : SITE_NAME;
  const metaDescription = description || "Professional fleet detailing services";
  const metaImage = ogImage || DEFAULT_OG_IMAGE;
  const canonicalUrl = canonical || SITE_URL;
  const altCanonical = canonicalUrl.replace(SITE_URL, `${SITE_URL}/${altLang}`);

  return (
    <Helmet
      htmlAttributes={{ lang }}
      title={fullTitle}
      meta={[
        { name: 'description', content: metaDescription },
        ...(keywords ? [{ name: 'keywords', content: keywords }] : []),
        ...(noIndex ? [{ name: 'robots', content: 'noindex, nofollow' }] : []),
        { property: 'og:title', content: fullTitle },
        { property: 'og:description', content: metaDescription },
        { property: 'og:image', content: metaImage },
        { property: 'og:url', content: canonicalUrl },
        { property: 'og:type', content: ogType },
        { property: 'og:site_name', content: SITE_NAME },
        { property: 'og:locale', content: lang === 'es' ? 'es_ES' : 'en_US' },
        { name: 'twitter:card', content: 'summary_large_image' },
        { name: 'twitter:title', content: fullTitle },
        { name: 'twitter:description', content: metaDescription },
        { name: 'twitter:image', content: metaImage },
      ]}
      link={[
        { rel: 'canonical', href: canonicalUrl },
        { rel: 'alternate', hrefLang: lang, href: canonicalUrl },
        { rel: 'alternate', hrefLang: altLang, href: altCanonical },
        { rel: 'alternate', hrefLang: 'x-default', href: canonicalUrl },
      ]}
    />
  );
};

export default SEO;
